import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import Button from '../../components/Button/Button';
import { ModalButtonRow, ModalTitle } from '../../components/Modal/Modal';
import { messages } from '../../constants/NowPlaying';
import QA from '../../constants/QATags';

import './StillListeningBody.scss';

export class StillListeningBody extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    intentPlayTrack: PropTypes.func,
    escKeyPressed: PropTypes.bool,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.escKeyPressed && this.props.escKeyPressed !== newProps.escKeyPressed) {
      this.keepListening();
    }
  }

  keepListening = () => {
    this.props.intentPlayTrack({
      logPlaybackActionsAnalytics: false,
      userTimedOut: true,
    });
    this.props.closeModal();
  };

  render() {
    const buttonToRender = [
      <Button key={0} onClick={this.keepListening} qaTag={QA.KLB}>
        <FormattedMessage {...messages.stillListeningCTA} />
      </Button>,
    ];
    return (
      <div className='StillListeningBody'>
        <ModalTitle>
          <FormattedMessage {...messages.stillListeningTitle} />
        </ModalTitle>
        <div className='StillListeningBody__subtitle'>
          <FormattedMessage {...messages.stillListeningBody} />
        </div>
        <ModalButtonRow buttons={buttonToRender} />
      </div>
    );
  }
}

export default connect(null, {
  closeModal: Actions.Modal.closeModal,
  intentPlayTrack: Actions.Playback.intentPlayTrack,
})(StillListeningBody);
